import { enqueueSnackbar } from "notistack";
import { useTranslation } from "react-i18next";

import CommonAlert from "@/components/CommonAlert";
import { useDeleteShiftMutation } from "@/requests/daily-status.queries";

function DeleteDriverStatus({ deletionId, handleClose }: { deletionId: string | null; handleClose: () => void }) {
    const { mutateAsync, isPending } = useDeleteShiftMutation();

    const { t } = useTranslation();

    const handleConfirm = async () => {
        if (isPending || !deletionId) return;
        try {
            await mutateAsync(deletionId);

            enqueueSnackbar(t("driverStatusUpdated"), { variant: "success" });
            handleClose();
        } catch (error) {
            console.error("Registration error:", error);
        }
    };

    return (
        <CommonAlert
            open={!!deletionId}
            loading={isPending}
            description="confirmations.deleteShift"
            color="error"
            onClose={handleClose}
            handleConfirm={handleConfirm}
        />
    );
}

export default DeleteDriverStatus;
